
<div
  class="resource-icon"
  [ngClass]="[
  emphasizeText ? 'emphasis' : '',
  angryColorWhenQuantityExceedsMax && maxQuantity >= 0 && quantity > maxQuantity ? 'angry' : itemClass,
  name === 'nothing' ? 'nothing' : ''
]">
  <app-game-icon class="icon" [icon]="icon" [inlineIconSize]="inlineIconSize"></app-game-icon>
  <span class="name" *ngIf="name" [ngxTippy]="description">{{ name }}</span>
  <span class="quantity" *ngIf="quantity >= 0">
    {{ showX ? 'x' : '' }}{{ quantity | number }}<span *ngIf="!maxIsNotImportant">{{ maxQuantity >= 0 ? '/' + (maxQuantity | number) : '' }}</span>
  </span>
</div>
